import { formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { QuoteService } from '../../../quote.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PolicyService } from '../../../../policy/policy.service';
import { GridOptions } from 'ag-grid-community';
import { LocalStorageService } from 'ngx-webstorage';
import { EquineService } from '../../equine.service';

const DOCUMENT_TYPE_LABELS: { [key: number]: string } = {
  1: 'Quote',
  2: 'Policy'
};

@Component({
  selector: 'app-equine-quote-documents',
  templateUrl: './equine-quote-documents.component.html',
  styleUrls: ['./equine-quote-documents.component.css']
})
export class EquineQuoteDocumentsComponent implements OnChanges, OnInit {
  @Input() quote: any;
  rowData: any[] = [];
  loading = false;
  gridOptions: GridOptions = {};
  isInsurer = false;
  vetCertMsg: string;
  certMsgStyle: boolean;

  constructor(
    private quoteService: QuoteService,
    private equineService: EquineService,
    private snackBar: MatSnackBar,
    private modalService: NgbModal,
    private policyService: PolicyService,
    private sessionSt: LocalStorageService
  ) {}

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_insurer')) {
      this.isInsurer = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.quote?.id) {
      this.getDocuments();
    } else {
      this.rowData = [];
    }
  }

  /* 
  * Upload Documents
  */
  docTitle: string = '';
  fileToUpload: File = null;
  documentID: string = '';
  documentsEditMode: boolean = false;
  openDocumentsPopup(content) {
    this.documentID = '';
    this.docTitle = '';
    this.fileToUpload = null;
    this.quote.quote_document = '';
    this.documentsEditMode = false;
    this.modalService.open(content, { centered: true });
  }

   // UPLOAd DOCUMENT
   getUploadedFile(files) {
    this.fileToUpload = files.item(0);
    this.quote.quote_document = this.fileToUpload.name;
  }


  documentUpload() {
    let formData = new FormData();
    formData.append("file_name", this.fileToUpload);
    formData.append("quote_id", this.quote.id);
    formData.append("broker_id", this.quote.broker_id);
    formData.append("title", this.docTitle);
    formData.append('is_uploaded_manually', '1');
    formData.append('is_uploaded_via_document_tab', '1');

    this.quoteService.saveQuoteDocument(formData, this.quote.is_policy)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.getDocuments();
            // this.gridOptions.rowData.push({
            //   'id': response.result.id,
            //   'title': response.result.title,
            //   'quote_version': this.quote.sequence_number,
            //   'created_date': response.result.created_at,
            //   'is_static': 0,
            //   'download_path': response.result.file_path + '/' + response.result.file_name,
            // });
            // this.gridOptions.api.setRowData(this.gridOptions.rowData);


            // this.gridOptions.api.refreshCells();
            this.modalService.dismissAll();
            this.snackBar.open('Document uploaded.', '', {
              duration: 5000,
            });
          } else {
            this.snackBar.open('Unable to upload document.', '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });
  }

  /** Download document using same flow as breakdown/quote service (expects id, title, file_name). */
  downloadDoc(doc: any): void {
    if (!doc || !doc.id) {
      this.snackBar.open('Document not available for download.', 'Close', { duration: 3000 });
      return;
    }
    const fileDetails = {
      id: doc.id,
      title: (doc.title || doc.document_title || 'document').trim() || 'document',
      file_name: doc.file_name || doc.file_path || 'document.pdf'
    };
    this.quoteService.downloadDocs(fileDetails);
  }

  getDocuments() {
    const type = this.quote.is_policy == 1 ? 2 : 1;
    this.loading = true;
    this.equineService.getDocuments(this.quote.id, type)
      .subscribe(
        (response: any) => {
          this.loading = false;
          if (response.success) {
            this.rowData = (response.result || []).map((doc: any) => ({
              ...doc,
              document_type_label: DOCUMENT_TYPE_LABELS[type] || (doc.type === 2 ? 'Policy' : 'Quote')
            }));
          } else {
            this.rowData = [];
          }
        },
        (error: any) => {
          this.loading = false;
          this.rowData = [];
        }
      );
  }

    /*
  * UPDATE DOCUMENT
  */
    updateDocument() {
      let data: any = '';
      data = {
        document_id: this.documentID,
        title: this.docTitle,
        is_uploaded_manually: true
      };
      this.quoteService.updateDocument(data)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.modalService.dismissAll();
              this.rowData.forEach((res) => {
                if (this.documentID == res.id && res.is_static == 0) {
                  res.title = this.docTitle
                }
              });
              this.gridOptions.api.setRowData(this.rowData);
              this.gridOptions.api.refreshCells();
              this.snackBar.open(response.message, '', {
                duration: 5000,
              });
            } else {
              this.snackBar.open('Unable to update title. Please try again later.', '', {
                duration: 5000,
                panelClass: 'text-danger'
              });
            }
  
          });
    }
  
    /*
    * Delete Document
    */
    deleteDocument() {
      let data: any = '';
      data = {
        document_id: this.documentID
      };
      this.quoteService.deleteDocument(data)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.modalService.dismissAll();
              let rowsDoc = [];
              this.rowData.forEach((res) => {
                if (this.documentID != res.id) {
                  rowsDoc.push(res);
                }
              });
              const selectedRow = this.gridOptions.api.getFocusedCell()
              const id = this.gridOptions.rowData[selectedRow.rowIndex].i
  
              this.gridOptions.rowData.splice(selectedRow.rowIndex, 1)
              this.gridOptions.api.setRowData(this.gridOptions.rowData)
  
              this.snackBar.open(response.message, '', {
                duration: 5000,
              });
            } else {
              this.snackBar.open(response.message, '', {
                duration: 5000,
                panelClass: 'text-danger'
              });
            }
  
          });
    }
  
  /*
  * Regenerate Schedule
  */
  schMsg: string = '';
  regenerate_schedule(reSchedule) {
    this.policyService.regenerateDocuments(this.quote.id)
      .subscribe(
        (response: any) => {
          this.getDocuments();
          this.schMsg = response.message;
          this.modalService.open(reSchedule, { centered: true });
        });
  }

  submit_vet_certificate() {
    const data = {
      quote_id: this.quote.id,
      vet_certificate_submitted: this.quote.vet_certificate_submitted
    };
    this.quoteService.submitVetCertificate(data)
      .subscribe(
        (response: any) => {
          this.modalService.dismissAll();
          if (response.success) {
            this.quote.vet_cert_upload_date = formatDate(new Date(), 'dd-MM-yyyy HH:mm a', 'en-US');
            this.snackBar.open(response.message, '', {
              duration: 5000,
            });
          } else {
            this.snackBar.open(response.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }
        });
  }
}
